import { render, staticRenderFns } from "./greenSupply.vue?vue&type=template&id=228aacbe&scoped=true"
import script from "./greenSupply.vue?vue&type=script&lang=js"
export * from "./greenSupply.vue?vue&type=script&lang=js"
import style0 from "./greenSupply.vue?vue&type=style&index=0&id=228aacbe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228aacbe",
  null
  
)

export default component.exports